import { ReactNode } from "react";

import AssistantPanelAskButton from "components/AssistantPanel/AskButton";
import { Cross } from "components/icons/generated";

import Box from "../Box";
import ButtonIcon from "../ButtonIcon";
import Typography from "../Typography";
import styles from "./styles.module.css";

type FullScreenModalHeaderProps = {
  children: ReactNode;
  onClose: () => void;
};

const FullScreenModalHeader = ({ children, onClose }: FullScreenModalHeaderProps) => {
  return (
    <Box direction="row" justify="between" padding="large" align="center" className={styles.header}>
      <Typography className={styles.title} tag="h1">
        {children}
      </Typography>
      <Box gap="medium" align="center">
        <AssistantPanelAskButton entryPoint="full_screen_modal" size="small" />
        <ButtonIcon icon={Cross} onPress={onClose} variant="ghost">
          Close
        </ButtonIcon>
      </Box>
    </Box>
  );
};

FullScreenModalHeader.displayName = "DS.FullScreenModal.Header";

export default FullScreenModalHeader;
